var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99982 9.65564L2.97464 4.63047C2.89654 4.55236 2.7699 4.55236 2.6918 4.63047L1.98469 5.33757C1.90659 5.41568 1.90659 5.54231 1.98469 5.62042L7.64657 11.2823C7.84183 11.4776 8.15842 11.4776 8.35368 11.2823L14.0156 5.61972C14.0937 5.54162 14.0937 5.41499 14.0156 5.33688L13.3085 4.62977C13.2304 4.55167 13.1038 4.55167 13.0257 4.62977L7.99982 9.65564Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.08c4c9eff4bd80c29d503bd2306c0d12.svg";
export { ForwardRef as ReactComponent };